import React from 'react'

import { Separator } from '@components/Separator'
import { useDate } from '@hooks/dates'
import { useFindProfile } from '@hooks/profile'

import { InfoContainer, Label, SectionTitle, SubTitle } from './styles'

export function SiteInformation() {
  const { getWeekDayBasedOnNumber } = useDate()

  const { data: rawUser } = useFindProfile()
  const user = rawUser ?? ({} as NonNullable<typeof rawUser>)

  const isAdmin = user.selectedSite.roles.includes('admin')

  const weekDay = getWeekDayBasedOnNumber(
    user.selectedSite.startOfWeek.toString(),
  )

  return (
    <>
      <SectionTitle>Site Information</SectionTitle>
      <Separator mb={10} />

      <InfoContainer>
        <SubTitle>Country</SubTitle>
        <Label>{user.selectedSite.country}</Label>
      </InfoContainer>
      <InfoContainer>
        <SubTitle>Region</SubTitle>
        <Label>{user.selectedSite.region}</Label>
      </InfoContainer>

      <>
        {isAdmin || user.isGlobalAdmin ? (
          <>
            <InfoContainer>
              <SubTitle>Shift Start Time</SubTitle>
              <Label>{user.selectedSite.shiftStartTime}</Label>
            </InfoContainer>
            <InfoContainer>
              <SubTitle>Shift</SubTitle>
              <Label>{`Starts ${user.selectedSite.shiftStartTime}AM and ends ${user.selectedSite.shiftEndTime}PM`}</Label>
            </InfoContainer>
            <InfoContainer>
              <SubTitle>Week Starts On</SubTitle>
              <Label>{weekDay}</Label>
            </InfoContainer>
            <InfoContainer>
              <SubTitle>Time Zone Name</SubTitle>
              <Label>{user.selectedSite.timeZoneName}</Label>
            </InfoContainer>
            <InfoContainer>
              <SubTitle>UTC Offset</SubTitle>
              <Label>{user.selectedSite.utcOffset}</Label>
            </InfoContainer>
          </>
        ) : null}
      </>
    </>
  )
}
